import studentHighlightsActions from '../actions/StudentHighlightsActions';

const defaultState = {
    hasValidSelection: false,
    selectionInHighlight: false,
    annotatingContentId: null,
    annotatingContentType: null,
    focusedAnnotation: null,
    annotationList: [],
    annotationsVisibility: true,
};

export default function (state = defaultState, action) {
    switch (action.type) {
    case studentHighlightsActions.types.STUDENT_HAS_VALID_SELECTION:
        return Object.assign({}, state, {
            hasValidSelection: action.hasValidSelection,
        });

    case studentHighlightsActions.types.STUDENT_SELECTION_IN_HIGHLIGHT:
        return Object.assign({}, state, {
            selectionInHighlight: action.selectionInHighlight,
        });

    case studentHighlightsActions.types.ANNOTATING_CONTENT:
        return Object.assign({}, state, {
            annotatingContentId: action.annotatingContentId,
            annotatingContentType: action.annotatingContentType,
        });

    case studentHighlightsActions.types.FOCUSED_ANNOTATION:
        return Object.assign({}, state, {
            focusedAnnotation: action.annotationSelector,
        });

    case studentHighlightsActions.types.ANNOTATION_LIST:
        return Object.assign({}, state, {
            annotationList: action.annotationList,
        });

    case studentHighlightsActions.types.ANNOTATION_VISIBILITY:
        return Object.assign({}, state, {
            annotationsVisibility: action.annotationsVisibility,
        });

    default:
        return state;
    }
}
